module.exports = __webpack_public_path__ + "assets/img/kv-1edd12ce.jpg";